var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.network)?_c('players',{attrs:{"network":_vm.network}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }